import { cn } from '../../lib/utils';
import { ASPECT_RATIOS } from '../../lib/models';

/** Visual aspect-ratio selector for the image studio. */
export default function AspectRatioPicker({ value, onChange }) {
  return (
    <div>
      <p className="mb-1.5 text-xs font-medium uppercase tracking-wide text-content-subtle">
        Aspect ratio
      </p>
      <div className="grid grid-cols-5 gap-2">
        {ASPECT_RATIOS.map((r) => {
          const active = r.value === value;
          const [w, h] = r.value.split(':').map(Number);
          const boxW = 22;
          const boxH = (boxW * h) / w;
          return (
            <button
              key={r.value}
              type="button"
              onClick={() => onChange(r.value)}
              className={cn(
                'flex flex-col items-center gap-1.5 rounded-lg border p-2 transition-colors',
                active
                  ? 'border-brand-400 bg-brand-500/10'
                  : 'border-border/70 hover:border-border-strong'
              )}
              title={`${r.label} (${r.value})`}
            >
              <span className="flex h-7 items-center justify-center">
                <span
                  className={cn('rounded-sm', active ? 'bg-brand-400' : 'bg-content-subtle')}
                  style={{ width: boxW, height: Math.max(8, boxH) }}
                />
              </span>
              <span className={cn('text-[10px]', active ? 'text-content' : 'text-content-subtle')}>
                {r.value}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
